import { jsx as s, jsxs as l } from "react/jsx-runtime";
const c = () => /* @__PURE__ */ s("svg", { viewBox: "0 0 33 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l("g", { id: "Vector", children: [
  /* @__PURE__ */ s(
    "path",
    {
      d: "M32.2976 0H31.8335C29.9194 0 28.5504 1.02643 27.982 2.84863L21.4854 24H21.9262C23.8404 24 25.2209 22.962 25.7778 21.1398L32.2976 0Z",
      className: "cls-2"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M25.7197 0H24.9656C23.0514 0 21.6941 1.02643 21.1256 2.84863L14.629 24H15.3599C17.2741 24 18.6546 22.962 19.2115 21.1398L25.7197 0Z",
      className: "cls-2"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M11.6939 0H10.3482C8.434 0 7.05347 1.02643 6.49662 2.84863L0 24H1.34573C3.25991 24 4.62884 22.962 5.1857 21.1398L11.6939 0Z",
      className: "cls-2"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M18.8519 0H17.8194C15.9052 0 14.5363 1.02643 13.9678 2.84863L7.48279 24H8.50369C10.4179 24 11.7984 22.962 12.3553 21.1398L18.8519 0Z",
      className: "cls-2"
    }
  )
] }) });
export {
  c as SgiLogoSvgCondensed
};
